import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

function SaaSApplicationLogo({ domain = '', cell = '' }) {
  const [hasError, setHasError] = useState(false) // Reset error state if domain changes
  useEffect(() => {
    setHasError(false)
  }, [domain])
  const token = process.env.REACT_APP_LOGO_DEV_KEY
  const src =
    domain && token && !hasError
      ? `https://img.logo.dev/${domain}?token=${token}&size=80`
      : '/media/logos/apps/logo-unknown.svg'
  return <img src={src} alt={`${cell} logo`} onError={() => setHasError(true)} />
}
SaaSApplicationLogo.propTypes = { domain: PropTypes.string, cell: PropTypes.string }

export default SaaSApplicationLogo
